import React, { Component } from "react";
import $ from "jquery";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";

export default class PatientSuveryResult extends Component {
  constructor() {
    super();

    this.state = {
      surveyQuestions: [{ optionsCopy: [] }],
      surveyAnswers: [],
      questionsId: [],
      SurveyQuestionsAndAnswers: [],
      noSurveyAnswers: false,
      allData: [],
      answersJson: {},
      isLoading: true,
    };
  }
  componentDidMount() {
    this.allPromises();
  }

  fetchSurveyQuestion() {
    var thisController = this;
    let surveyQuestions = new Promise((resolve, reject) => {
      $.ajax({
        url: "/my-jeeva-api/fetch-survey-item",
        method: "GET",

        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          surveyId: localStorage.getItem(`surveyIdOfTreatment`),
        },
        success: function (res) {
          if (res.success == true) {
            thisController.state.surveyQuestions = res.result;
            for (var i = 0; i < res.result.length; i++) {
              thisController.state.surveyQuestions[i]["optionsCopy"] = [];
              thisController.state.surveyQuestions[i].optionsCopy =
                res.result[i].options.split(",");
              thisController.state.questionsId[i] = res.result[i].id;
            }
            console.log(
              "Survey Questions Ids are :- " + thisController.state.questionsId
            );
            thisController.setState(thisController.state);
            if (resolve) {
              resolve();
            } else if (reject) {
              reject();
            }
          }
        },
      });
    });
    return surveyQuestions;
  }

  fetchSurveyAnswers() {
    var thisController = this;
    var surveyId = localStorage.getItem("surveyIdOfTreatment");

    let surveyAnswers = new Promise((resolve, reject) => {
      $.ajax({
        url: "/my-jeeva-api/fetch-survey-results",
        method: "GET",

        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          answeredBy: localStorage.getItem("patientAddmissionId"),
          surveyId: surveyId,
        },
        success: function (res) {
          if (res.success == true) {
            if (!res.result || Object.keys(res.result).length === 0) {
              thisController.state.noSurveyAnswers = true;
              thisController.setState(thisController.state);
            } else {
              console.log(
                "Survey Answers From PatientSurveyResult:-  " + res.result
              );
              var result = res.result;
              thisController.state.answersJson = JSON.parse(result.answersJson);
              // var answersArray = [];
              // var questionsArray = thisController.state.questionsId;
              // console.log("question ids are " , questionsArray );
              // for (var i = 0; i < questionsArray.length; i++) {
              //   answersArray[i] = answersJson[questionsArray[i]];
              // }
              // thisController.state.surveyAnswers = answersArray;
              thisController.state.noSurveyAnswers = false;
              thisController.setState(thisController.state);
              // console.log(
              //   "Only answers - " + answersArray
              // );

              // for (var i = 0; i < res.result.length; i++) {
              //   if (surveyId == res.result[i].surveyId) {
              //     for (
              //       var j = 0;
              //       j < thisController.state.questionsId.length;
              //       j++
              //     ) {
              //       answersArray[j] = JSON.parse(res.result[i].answersJson)[
              //         thisController.state.questionsId[j]
              //       ];
              //     }
              //     thisController.state.surveyAnswers = answersArray;
              //     thisController.state.noSurveyAnswers = false;
              //     thisController.setState(thisController.state);
              //     console.log(
              //       "Only answers - " + thisController.state.surveyAnswers
              //     );
              //   } else {
              //     console.log("No Suvery answers Found for this patient");
              //   }
              // }
              // thisController.setState(thisController.state);
            }

            if (resolve) {
              resolve();
            } else if (reject) {
              reject();
            }
          }
        },
      });
    });
    return surveyAnswers;
  }

  allPromises = () => {
    Promise.all([this.fetchSurveyQuestion(), this.fetchSurveyAnswers()]).then(
      () => {
        this.printResolved();
      }
    );
  };

  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>The patient has not responded to this survey. </p>
    </div>
  );

  printResolved = () => {

    var answersArray = [];
    var answersJson = this.state.answersJson;
    var questionsArray = this.state.questionsId;
    var surveyQuestionArr = this.state.surveyQuestions;
    console.log("question ids are ", questionsArray);

    for (var i = 0; i < questionsArray.length; i++) {
      answersArray[i] = answersJson[questionsArray[i]];
      if (answersArray[i] == null) {
        surveyQuestionArr.splice(i, 1)
        questionsArray.splice(i, 1)
      }
    }
    var questionsAndAnswers = [];
    for (let i = 0; i < surveyQuestionArr.length; i++) {
      var value = answersArray[i];
      if (Array.isArray(value)) {
        for (var j = 0; j < value.length; j++) {
          if (j != value.length - 1) {
            value[j] = value[j] + ","
          }
          else {
            value[j] = value[j]
          }
        }
      }
      questionsAndAnswers.push({
        question: surveyQuestionArr[i].question,
        answer: value,
      });
    }
    this.state.surveyQuestions = surveyQuestionArr;
    this.state.surveyAnswers = answersArray;
    this.state.allData = questionsAndAnswers;
    this.state.isLoading = false;
    this.setState(this.state);
    console.log("All Data is -> " + this.state.allData);
    console.log("Everything is fetched");
  };

  caseInsensitiveSort = (field) => (rowA, rowB) => {
    const a = rowA[field].toLowerCase();
    const b = rowB[field].toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  getColumns() {
    const columns = [
      {
        name: <b style={{ fontSize: "16px" }}>Questions</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('question'),
        selector: (row) => (
          <div
            className="textarea"
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "13px",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              borderRadius: "2px",
              textAlign: "start",
            }}
          >
            {row.question}
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Answers</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('answer'),
        selector: (row) => (
          <div
            className="textarea"
            style={{
              background: "inherit",
              height: "2.7em",
              resize: "none",
              paddingLeft: "13px",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              borderRadius: "2px",
              textAlign: "start",
              overflowY: "scroll"
            }}
          >
            {row.answer}
          </div>
        ),
      },
    ];
    return columns;
  }

  customStyles() {
    const customStyles = {
      headCells: {
        style: {
          // border: " 1px solid gray",
          justifyContent: "center",
        },
      },

      cells: {
        style: {
          // border: " 1px solid gray",
          justifyContent: "center",
        },
      },
    };
    return customStyles;
  }

  render() {
    return (
      <div>
        <link rel="stylesheet" href="./assets/css/patientSurveyResult.css" />
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <Link to="/projectmgmt/view-patient-survey">
            <img
              className="img-responsive"
              src="./assets/images/arrow.svg"
              style={{ marginLeft: "5px", cursor: "pointer" }}
            />
          </Link>

          <h6
            className="nav-item"
            style={{ color: "#282a65", marginTop: "10px", marginLeft: "15px" }}
          >
            {localStorage.getItem("surveyTitle")}
          </h6>
        </div>

        <div
          className="main-content1 survey-form" style={{ margin: "2vh" }}
        >
      
          {this.state.isLoading && (
            <div style={{ padding: '20px', textAlign: 'center', width: "90vw", boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
              <p>Loading ...</p>
            </div>
          )}
          {!this.state.isLoading && this.state.allData.length === 0 && (
            <div style={{ padding: '20px', textAlign: 'center', width: "90vw", boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
              <p>The patient has not responded to this survey.</p>
            </div>
          )}
          {this.state.allData.length > 0 && this.state.noSurveyAnswers && (<div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                padding: '20px', textAlign: 'center', width: "90vw", boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)"
              }}
            >
              <p style={{ fontSize: "18px" }}>The patient has not responded to this survey.</p>
            </div>
          </div>)}
          {!this.state.noSurveyAnswers && this.state.allData.length > 0 && (<div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              className="col-lg-12 "
              style={{
                width: "90vw",
                paddingTop: "5vh"

              }}
            >
              <div style={{ marginBottom: "10px", width: "100vw", boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                <DataTable
                  columns={this.getColumns()}
                  data={this.state.allData}
                  customStyles={this.customStyles()}
                  noDataComponent={<this.CustomNoDataComponent />}

                />
              </div>
            </div>
          </div>)}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/PatientSuveryResult.js